import { createSlice } from '@reduxjs/toolkit';
import {
  ClearUserPasswordAction,
  GetUserFormAction,
  GetUserFormRejectAction,
  GetUserFormResolveAction,
  GetUserRejectAction,
  GetUserResolveAction,
  IUserState,
  PutUserPasswordAction,
  PutUserPasswordRejectAction,
  PutUserPasswordResolveAction,
  PutUserPasswordSuccessAction,
} from './types';

const name = 'user';

const initialState: IUserState = {
  isUserReady: false,
  isRetrievingUser: false,
  changePassword: {
    isChanging: false,
    mustChangePassword: null,
    errorMessage: null,
    isRedirecting: false,
  },
  data: {},
  formSettings: {},
  isRetrievingFormSettings: false,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    getUser: (state) => {
      state.isRetrievingUser = true;
    },
    getUserResolve: (state, action: GetUserResolveAction) => {
      const { payload: { success, data } = {} } = action;
      state.isUserReady = success;
      state.data = data || {};
      state.isRetrievingUser = false;
      state.formSettings = {};
    },
    getUserReject: (state, action: GetUserRejectAction) => {
      state.isRetrievingUser = false;
    },
    putUserPassword: (state, action: PutUserPasswordAction) => {
      state.changePassword.isChanging = true;
      state.changePassword.isRedirecting = false;
      state.changePassword.mustChangePassword = null;
      state.changePassword.errorMessage = null;
    },
    putUserPasswordRedirect: (state, action: PutUserPasswordSuccessAction) => {
      state.changePassword.isRedirecting = true;
    },
    clearUserPasswordRedirect: (state, action: ClearUserPasswordAction) => {
      state.changePassword.isRedirecting = false;
    },
    putUserPasswordResolve: (state, action: PutUserPasswordResolveAction) => {
      state.changePassword.isChanging = false;
    },
    putUserPasswordReject: (state, action: PutUserPasswordRejectAction) => {
      const { payload: { message } = {} } = action;
      state.changePassword.isChanging = false;
      state.changePassword.isRedirecting = false;
      state.changePassword.errorMessage = message;
    },
    getUserForm: (state, action: GetUserFormAction) => {
      state.isRetrievingFormSettings = true;
    },
    getUserFormResolve: (state, action: GetUserFormResolveAction) => {
      const { payload: { data } = {} } = action;
      state.isRetrievingFormSettings = false;
      state.formSettings = data;
    },
    getUserFormReject: (state, action: GetUserFormRejectAction) => {
      state.isRetrievingFormSettings = false;
      state.formSettings = {};
    },
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
